import { Dropdown } from "../common/Dropdown";
import { TextField } from "../common/TextField";
import SearchIcon from "../../../../assets/icons/search.svg";
import RefreshIcon from "../../../../assets/icons/refresh.svg";
import { Link, useNavigate } from "react-router-dom";
import "./index.css";
import { SideBar } from "../Sidebar";
import { useEffect, useState } from "react";
import { apiCall, METHOD } from "../../../../service/baseApiCall";
import { DELETE_COUPON, GET_SAM_SWITCH } from "../../../../service/apiEndPoints";
import { toast } from "react-toastify";
import moment from "moment";
import clsx from "clsx";
import TablePagination from "../common/TablePagination";
import { couponManage, validateToken } from "../../../App/utils/util";
import galaxyStore from "../../../../assets/icons/galaxy_store_1.png"
import googlePlay from "../../../../assets/icons/goggleplay_1.png"
import Switch from "@mui/material/Switch"
import { CouponModal } from "../Coupon/modal";
import ReLoginModal from "../common/ReloginModal";

export const SamWatch = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [selectedOs, setSelectedOs] = useState("all");
  const [search, setSearch] = useState("");
  const [toggleTmpVal, setToggleTepVal] = useState<ToggleTmp>({})
  const [isReloginOpen, setReloginIsOpen] = useState(false);
  const [couponModal, setCouponModal] = useState(false); 
  const [selectedProduct, setSelectedProduct] = useState<any>();
  const [ isUploadTarget, setIsUploadTarget ] = useState<any>([]);
  const navigate = useNavigate();
  interface ToggleTmp {
    [sku: string]: ToggleTmpValue 
  }

  interface ToggleTmpValue {
    enable_get_coupon: boolean,
    enable_now_coupon: boolean,
  }

  useEffect(() => {
    loadData();
  }, [limit, page]);

  const loadData = async () => {
    if( validateToken() === false ) { navigate("/login") }
    setLoader(true);
    const URL = GET_SAM_SWITCH.replace(":type", "watch")
      .replace(":limit", limit.toString())
      .replace(":page", page.toString())
      .replace(":os", selectedOs === "all" ? "" : selectedOs)
      .replace(":name_sku", search);
    apiCall(
      URL,
      {},
      (res: any) => {
        if (res?.success) {
          setData(res?.data);
          setTotalCount(res?.pagination?.total);
          setTotalPages(res?.pagination?.total_page);

          let tmpArr: ToggleTmp = {} 
          res?.data.forEach( (elem: any)=> {
            tmpArr[elem.sku] = { "enable_get_coupon": elem.enable_get_coupon, "enable_now_coupon": elem.enable_now_coupon } 
          })
          setToggleTepVal(tmpArr)

          setLoader(false);
        } else {
          if (res?.data?.message === "record not found") {
            setData([]);
            setTotalCount(0);
            setLoader(false);
          }
        }
      },
      (err: any) => {
        console.log(err);
        setLoader(false);
        toast.error("something went wrong!");
      },
      METHOD.GET,
      {}
    );
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    setPage(0);
    loadData();
  };

  const handleUpload = ( (e:any) => {
    if( e?.coupon_enabled || isUploadTarget[e.sku] ) {
      toast.error("업로드된 아이템은 CSV 업로드가 불가능합니다.")
      return
    }
    setSelectedProduct(e)
    setCouponModal(!couponModal)
  })

  const handleDelete = (e: any) => {
    if( !e?.coupon_enabled || isUploadTarget[e.sku] === false ) {
      toast.error("업로드 되지 않은 아이템은 삭제가 불가능합니다.")
      return
    }

    if(window.confirm("정말 삭제하시겠습니까?")) {
      apiCall(DELETE_COUPON.replace(":sku", e?.sku),
        {},
        (res: any) => {
          loadData()
          toast.success("쿠폰을 성공적으로 삭제하였습니다.")
        },
        (err: any) => {
          console.log(err)
          if( err === "unauthorized" ) {
            toast.error("토큰이 만료되었습니다. 다시 로그인 해주세요.")
          } else {
            toast.error("쿠폰 삭제를 실패하였습니다.")
          }
        },
        METHOD.DELETE
      )
    }
  }

  return (
    <div className="flex w-full">
      <SideBar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        fromCoupon={false}
      />
      <div
        className={clsx(
          "mainClass relative flex flex-col justify-center overflow-auto",
          collapsed
            ? "ml-12 lg:ml-14 xl:ml-14 w-full"
            : "ml-12 w-full md:ml-[13em]"
        )}
      >
        <div className="flex w-full flex-row justify-between">
          <span className="text-3xl font-bold p-4">Sam Watch</span>
          <Link
            className="text-white bg-[#0EB4F3] hover:bg-[#58c7f3] font-medium text-center rounded-lg h-fit text-sm m-4 mt-5 px-2 py-2.5 w-24"
            to="/dashboard/samwatch/register"
          >
            Register
          </Link>
        </div>

        <div className="flex flex-row justify-between align-middle mt-14 ml-5 mr-3 md:ml-10 md:mr-5">
          <form
            className="flex flex-col md:flex-row justify-between w-full"
            onSubmit={handleSubmit}
          >
            <div className="flex flex-col md:flex-row ">
              <Dropdown
                className="mr-4 w-fit"
                for="search"
                onChange={(e: string) => setSelectedOs(e)}
                items={[
                  { key: "All", value: "all" },
                  { key: "Galaxy Store", value: "tizen" },
                  { key: "Google Play", value: "wear" },
                ]}
                label="Store"
              ></Dropdown>
              <TextField
                label="Name or SKU"
                placeholder="Name or SKU"
                for="search"
                onchange={(e: string) => setSearch(e)}
              ></TextField>
            </div>
            <div className="[&>*]:mr-2 [&>*]:hover:cursor-pointer mr-0 mt-8 flex flex-row h-10">
              <button>
                <img src={SearchIcon} alt="" />
              </button>
              <img src={RefreshIcon} onClick={loadData} alt="" />
            </div>
          </form>
        </div>
        <div className="divide-y mt-5">
          <div />
          <div />
        </div>
        <div className="ml-5 mr-3 md:ml-10 md:mr-5 mt-5 flex flex-row justify-between">
          <div className=" flex flex-row">
            <span className="font-bold">Items:</span>
            <span className="text-[#697274] ml-2 animate-pulse">
              {loader ? (
                <div className="h-2 w-4 bg-slate-600 rounded mt-2" />
              ) : (
                totalCount
              )}
            </span>
          </div>
          <Dropdown
            className="-mt-4 -mb-2 mr-2"
            for="search"
            onChange={(e: number) => setLimit(e)}
            items={[
              { key: "10", value: 10 },
              { key: "15", value: 15 },
              { key: "20", value: 20 },
              { key: "25", value: 25 },
              { key: "50", value: 50 },
              { key: "100", value: 100 },
            ]}
          />
        </div>
        <div className="ml-5 mr-3 md:ml-10 md:mr-7 mt-5 overflow-auto">
          <table className="w-full [&>*]:border">
            <thead className="">
              <tr className="bg-[#EFF7FD] [&>*]:p-5 [&>*]:border">
                <th>No</th>
                <th>
                  <div style={{ fontSize: "10pt" }}>
                    (Available / Used)
                  </div>
                  Name
                </th>
                <th>Store</th>
                <th>Manage CSV</th>
                <th style={{minWidth: "134px"}}>Manage</th>
                <th style={{minWidth: "124px"}}>Created At</th>
              </tr>
            </thead>
            <tbody className="[&>*]:border">
              {loader ? (
                <tr className="[&>*]:border-r-[1px] animate-pulse">
                  <td>
                    <div className="h-2 bg-slate-700 rounded" />
                  </td>
                  <td>
                    <div className="h-2 bg-slate-700 rounded" />
                  </td>
                  <td>
                    <div className="h-2 bg-slate-700 rounded" />
                  </td>
                  <td>
                    <div className="h-2 bg-slate-700 rounded" />
                  </td>
                  <td>
                    <div className="h-2 bg-slate-700 rounded" />
                  </td>
                  <td>
                    <div className="h-2 bg-slate-700 rounded" />
                  </td>
                </tr>
              ) : !data.length ? (
                <tr className="[&>*]:border-r-[1px]">
                  <td colSpan={7} className="font-bold text-gray-700">
                    No Data to Show
                  </td>
                </tr>
              ) : (
                data.map((e: any, i) => (
                  <tr className="[&>*]:border-r-[1px]">
                    <td>{(page - 1) * limit + ++i}</td>
                    <td
                      className="hover:cursor-pointer"
                      onClick={() => {
                        navigate(`/dashboard/samwatch/${e?.sku}`);
                      }}
                    >
                      {
                        e?.coupon_enabled ? 
                        <div style={{"fontSize": "10pt"}}> {`( ${e?.available || 0} / ${e?.used || 0} )`}</div>
                        : null
                      }
                      {e?.name}
                    </td>
                    <td>
                      <div style={{ display: "flex", minWidth: "100px" }}>
                        {e?.os?.includes("wear") && <a className="store-img" href={e?.wear_link} target="_blank" rel="noopener noreferrer"> <img src={ googlePlay } alt="" /> </a> }
                        {e?.os?.includes("tizen") && <a className="store-img" href={e?.tizen_link} target="_blank" rel="noopener noreferrer"> <img src={ galaxyStore } alt="" /> </a> }
                      </div>
                    </td>
                    <td>
                      <div>
                        <div
                          className={`text-white ${ isUploadTarget[e.sku] || e?.coupon_enabled ? 
                            "bg-[#808080]" : "bg-[#0EB4F3] hover:bg-[#58c7f3]"}  
                            font-medium text-center rounded-lg h-fit text-sm m-4 mt-5 px-2 py-2.5 w-24`}
                          style={{ margin: "0.2rem", display:"inline-block", cursor:"pointer" }}
                          onClick={ () => handleUpload(e) }
                        >
                          Upload
                        </div>
                        <div
                          className={`text-white ${ isUploadTarget[e.sku] === false || !e?.coupon_enabled ? 
                            "bg-[#808080]" : "bg-[#d32f2f] hover:bg-[#dd6868]"}  
                            font-medium text-center rounded-lg h-fit text-sm m-4 mt-5 px-2 py-2.5 w-24`}
                          style={{ margin: "0.2rem", display:"inline-block", cursor:"pointer" }}
                          onClick={ () => handleDelete(e) }
                        >
                          Delete
                        </div>
                        
                      </div>
                    </td>
                    <td>
                      <div>
                        <div>
                          <span>Get</span>
                          <Switch 
                            color={ "error"}
                            id={e?.sku + "get"}
                            name="enable_get_coupon"
                            checked={ toggleTmpVal[e.sku].enable_get_coupon }
                            disabled={ isUploadTarget[e.sku] === false  || toggleTmpVal[e.sku].enable_now_coupon || e.coupon_enabled === false ? true : false }
                            onChange={ (ev, val) => { 
                                                    couponManage(val, 
                                                                 ev.target.name,
                                                                 e?.sku, 
                                                                 setToggleTepVal 
                                                                ) 
                                                    }
                                     } 
                          />
                        </div>
                        <hr/>
                        <div>
                          <span>Now</span>
                          <Switch 
                            id={e?.sku + "now"}
                            name="enable_now_coupon"
                            checked={ toggleTmpVal[e.sku].enable_now_coupon }
                            disabled={ toggleTmpVal[e.sku].enable_get_coupon ? true : false }
                            onChange={ (ev, val) => { 
                                                    couponManage(val, 
                                                                 ev.target.name, 
                                                                 e?.sku,
                                                                 setToggleTepVal 
                                                                ) 
                                                    } 
                                     } 
                          />
                        </div>
                      </div>
                    </td>
                    <td style={{minWidth: "183px"}}>
                      {moment(e?.created_at).format("YYYY/MM/DD HH:mm:ss")}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {loader || totalPages <= 1 ? undefined : (
          <TablePagination
            curPage={page}
            setCurPage={setPage}
            lastPage={totalPages}
          />
        )}
      </div>
      <CouponModal 
        couponModal = { couponModal }
        setCouponModal = { setCouponModal }
        setReloginIsOpen = { setReloginIsOpen }
        selectedProduct = {selectedProduct}
        setIsUploadTarget = { setIsUploadTarget }
        loadData = { loadData }
      />
      <ReLoginModal isOpen={isReloginOpen} setIsOpen={setReloginIsOpen} />
    </div>
  );
};
